<template lang="pug">
#Travel
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Travel" :HeaderGlobalBreadcrumb="breadcrumb")

    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading Detail Travel
                .header-cta.flex.items-center

        .box__body.p-4
            template(v-if="load_data_status_travel.status === 'loading'")
                Loading(show="true")
            template(v-else-if="travel && travel.length > 0")
                .table-static.w-full
                    table
                        thead
                            tr
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody                                    
                            tr(v-for="(data,index) in travel" :key="data.id")
                                //- td {{ data.nik?data.nik:'-' }}
                                td 
                                    router-link.link-text(
                                        v-if="data.nik && data.nik.length > 0"
                                        :to="'/result/'+ encrypt(data.nik +'&&nik') +'/profile'"
                                        ) {{ data.nik?data.nik:'-' }}
                                //- td {{ data.nama?data.nama:'-' }}
                                td 
                                    router-link.link-text(v-if="data.nama && data.nama.length > 0" :to="'/search-by-name/'+ encrypt(data.nama, 'name')" target="_blank")
                                        | {{ data.nama?data.nama:'-' }}
                                    template(v-else) -
                                td {{ data.email?data.email:'-' }}
                                td {{ data.asal?data.asal:'-' }}
                                td {{ data.tujuan?data.tujuan:'-' }}
                                td {{ data.nomor_perjalanan?data.nomor_perjalanan:'-' }}
                                td {{ data.waktu_keberangkatan?data.waktu_keberangkatan:'-' }}
                                td {{ data.waktu_kedatangan?data.waktu_kedatangan:'-' }}
                                td {{ data.logTimestamp?data.logTimestamp:'-' }}
                                td {{ data.username?data.username:'-' }}
            NoDataAvailable(v-else)

</template>

<script>
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import { encrypt, decrypt } from '@/util/crypto';

export default {
    name: 'Travel',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Travel',
                    url: '/result/travel',
                },
            ],
            tableThead: [
                {
                    name: 'NIK',
                },{
                    name: 'Name',
                },{
                    name: 'Email',
                },{
                    name: 'Origin',
                },{
                    name: 'Destination',
                },{
                    name: 'Travel Number',
                },{
                    name: 'Departure',
                },{
                    name: 'Arrival',
                },{
                    name: 'Timestamp',
                },{
                    name: 'Username',
                }
            ],
            keySend:null,
        };
    },
    computed: {
        ...mapState([
            'load_data_status_travel',
            'travel',
            'profile_subheader',
            'profile_subheader_name',
            'load_data_status_profile_subheader',
            'load_data_status_profile_subheader_name'
        ]),
        status_subheader(){
            return {
                'sub':this.load_data_status_profile_subheader, 
                'name':this.load_data_status_profile_subheader_name
            }
        },
        key() {
            return this.$route.params.key;
        },
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        status_subheader(newData) {
            console.log('status_subheader - newData')
            console.log({newData})
            // EventEmit.$emit('openSearchByNamePaspor', 'test');
            // this.keySend = 'test'
            if (newData && (newData.name && newData.name.status === 'loading') || (newData.sub && newData.sub.status === 'loading')){
                this.$store.commit('setLoadDataStatusTravel',{
                    status: 'loading',
                    cancel: null,
                    code: null,
                });
            }else{
                let dataSub = this.profile_subheader
                let dataSubName = this.profile_subheader_name
                
                if (dataSubName.nik && dataSubName.nik!='-'){
                    this.keySend = dataSubName.nik
                }
                else if (dataSub.nik && dataSub.nik!='-'){
                    this.keySend = dataSub.nik
                    // console.log('TravelHistoryResult - watch - emit:openSearchByNamePaspor')
                }else{
                    this.$store.commit('setLoadDataStatusTravel',{
                        status: 'empty',
                        cancel: null,
                        code: null,
                    });
                    // console.log('TravelHistoryResult - watch - comit:setLoadDataStatusTravel:empty')
                }
            }
        },
        keySend(data) {
            console.log('keySend data')
            console.log({data})
            if (data){
                this.getData();
            }
        },
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        encrypt(key, type) {
            return encrypt(key+ '&&' +type);
        },
        async getData() {
            console.log('getData - this.route_name')
            console.log(this.route_name)
            if (this.route_name === 'result-travel') {
                await this.$store.dispatch('getTravelPl', [this.keySend, 'nik']);
            }
        },
    },
    mounted() {
        console.log('mounted travel')
        this.$store.commit('setLoadDataStatusTravel',{
            status: 'loading',
            cancel: null,
            code: null,
        });
        let decrypt_data = decrypt(this.key);
        decrypt_data = decrypt_data.split('&&');

        var key = decrypt_data[0];
        var type = decrypt_data[1];

        if (type == 'nik') {            
            this.keySend = key;
        } else {
            // console.log('TravelHistoryResult - mounted - setLoadDataStatusTravel:loading')
    
            let profileSub = this.profile_subheader
            let profileSubName = this.profile_subheader_name
            // console.log('TravelHistoryResult - mounted - profileSub')
            // console.log({profileSub})
            console.log({profileSub, profileSubName})
    
            if (profileSubName && profileSubName.nik && profileSubName.nik!='-')
                this.keySend = profileSubName.nik
            else if (profileSub && profileSub.nik && profileSub.nik!='-')
                this.keySend = profileSub.nik
                // EventEmit.$emit('openSearchByNameTravelHistory');
        }
    },
}
</script>

<style lang="sass">
</style>
